<div class="scrollable">
  <pre><code #code [highlight]="sourceCode" [languages]="['javascript']"></code></pre>
</div>
<div class="white-overlay" *ngIf="disabled"></div>
